import { findParentNodeClosestToPos, useEditorState } from "@tiptap/react";

import type { Editor } from "@tiptap/react";

export function useAvailableWidth(
  editor: Editor,
  getPos: () => number | undefined,
): number | undefined {
  return useEditorState({
    editor,
    selector: ({ editor: e }) => {
      const pos = getPos();

      if (pos === undefined) return undefined;

      const $pos = e.state.doc.resolve(pos);
      const cell = findParentNodeClosestToPos(
        $pos,
        (n) => n.type.name === "tableCell" || n.type.name === "tableHeader",
      );

      if (!cell) {
        return undefined;
      }

      // Subtract some pixels to account for cell padding and borders, so that the expression fits within the cell.
      const shift = 25;
      const colwidth = (cell.node.attrs.colwidth as number[] | null)?.[0];

      if (colwidth) {
        return colwidth - shift;
      }

      const cellDom = e.view.nodeDOM(cell.pos) as HTMLElement | null;

      if (cellDom) {
        const cellWidth = cellDom.offsetWidth;
        return cellWidth - shift;
      }

      return undefined;
    },
  });
}
